/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnalyticsDimensionValue,
  AnalyticsDimensionValue$inboundSchema,
} from "./analyticsdimensionvalue.js";

/**
 * The values a dimension actually holds inside the window, most frequent first, after the dataset has collapsed its observations.
 */
export type AnalyticsDimensionValuesResult = {
  dataset: string;
  dimension: string;
  values: Array<AnalyticsDimensionValue>;
};

/** @internal */
export const AnalyticsDimensionValuesResult$inboundSchema: z.ZodMiniType<
  AnalyticsDimensionValuesResult,
  unknown
> = z.object({
  dataset: z.string(),
  dimension: z.string(),
  values: z.array(AnalyticsDimensionValue$inboundSchema),
});

export function analyticsDimensionValuesResultFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsDimensionValuesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsDimensionValuesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsDimensionValuesResult' from JSON`,
  );
}
